import React from "react";
import { toast } from "react-toastify";
import { oneKlicks, sendEmail } from "../../../../../SDK/oneclick";
import { getuserdata } from "../../../../../services/apiService";

const EmailVerify = () => {
    const handleResend = async (e) => {
        e.preventDefault();
        try {
            // Fetch current user
            const userId = await getuserdata("id");
            if (!userId) {
                toast.error("User not found. Please login again.");
                return;
            }

            const readResponse = await oneKlicks.read("", "users", { id: userId }, "", "", "", "");
            if (!readResponse.success || !readResponse.data?.length) {
                toast.error("Failed to get user record.");
                return;
            }

            const user = readResponse.data[0];
            const userEmail = user.email;
            if (!userEmail) {
                toast.error("Email not found for this user.");
                return;
            }

            // Generate a secure unique token
            const generateToken = () => {
                const bytes = new Uint8Array(32);
                window.crypto.getRandomValues(bytes);
                return Array.from(bytes).map((b) => b.toString(16).padStart(2, "0")).join("");
            };

            const token = generateToken();

            // Save token on user record
            const updateResponse = await oneKlicks.update(
                "",
                "users",
                { activation_key: token, is_verified: false },
                { id: user.id }
            );

            if (!updateResponse.success) {
                toast.error("Could not prepare verification email. Try again.");
                return;
            }

            // Build verification URL
            const baseUrl = window.location.origin;
            const verifyUrl = `${baseUrl}/verify-email?token=${token}`;

            // Send email via OneKlicks email utility
            const subject = "Verify your email - MeddyList";
            const text = `Hi ${user.first_name || ""},\n\nPlease verify your email by clicking the link below:\n${verifyUrl}\n\nIf you did not request this, you can ignore this email.`;

            const emailResult = await sendEmail(userEmail, subject, text);
            if (emailResult?.success) {
                toast.success("Verification email sent.");
            } else {
                toast.error("Failed to send email. Please try again later.");
            }
        } catch (err) {
            console.error("Resend verification error:", err);
            toast.error("Something went wrong while resending email.");
        }
    };

    return (
        <div className="dc-haslayout dc-jobalertsdashboard re-sendverification">
            <div className="row">
                <div className="col-12 col-sm-12 col-md-12 ">
                    <div className="dc-jobalerts">
                        <div className="alert alert-warning fade show">
                            <em>Verification&nbsp;:&nbsp;</em>
                            <span>Your account is not verified. Please check your email for the verification</span>
                            <button
                                className="dc-alertbtn warning"
                                onClick={handleResend}
                            >
                                Resend email
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmailVerify;
